import theme from '@styles/theme';
export default {
  section: (background: string | null = null) => ({
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    height: ['716px', '716px', '1024px', '1024px', '46.875vw'],
    bg: theme.rawColors.neutralWhite,
    backgroundImage: background ? `url(${background})` : null,
    backgroundSize: 'cover'
  })
};